import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, CardContent } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    title: {
        paddingLeft: 60 + theme.spacing(2),
    },
    iconWrapper: {
        // background: 'linear-gradient(69.25deg, #577B16 16.6%, #3E580F 90.93%);',
        background: theme.palette.secondary.main,
        color: 'white',
        display: 'inline-block',
        borderRadius: 3,
        width: 60,
        height: 60,
        position: 'absolute',
        marginTop: -32,
        marginRight: theme.spacing(2),
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25);',
        textAlign: 'center',
        '& svg': {
            fontSize: '2.5rem',
            marginTop: theme.spacing(1.25),
        },
    },
}));

export interface CardTitleProps {
    icon: React.ReactNode;
    title: React.ReactNode;
}

export const CardTitle: React.FunctionComponent<CardTitleProps> = props => {
    const classes = useStyles();

    return (
        <CardContent>
            {props.icon && (
                <div className={classes.iconWrapper}>
                    {props.icon}
                </div>
            )}
            <Typography className={classes.title} variant="h5" component="h2">{props.title}</Typography>
        </CardContent>
    );
};
